import { ValueOfKey } from '../../../utils-types';

export const CUSTOMER_TYPE = {
  NUTRITION: 'NUTRITION',
  SCAN_IQ: 'SCAN_IQ',
} as const;

export type CustomerType = ValueOfKey<typeof CUSTOMER_TYPE>;
